import {$http} from '@/utils/https'
import {
    CHANGE_DATE,
    CHANGE_LOADING,
    CHANGE_SKIP,
    SET_ITEM,
    SET_LIST,
    SET_LIST_COUNT,
    SET_LIST_LENGTH,
} from '../mutation-types';

import {GET_LIST, GET_LIST_COUNT, GET_LIST_ITEM} from '../action-types';

import _ from 'lodash'

const state = {
    list: null,
    currentItem: null,
    isLoading: false,
    skip: 0,
    limit: 30,
    listLength: 0,
    date: {
        from: '',
        to: ''
    }
};

const getters = {
    list: state => state.list,
    listCount: state => state.listCount,
    currentItem: state => state.currentItem,
    listLength: state => state.listLength,
    skip: state => state.skip,
    limit: state => state.limit,
    isLoading: state => state.isLoading,
    date: state => state.date,
};

const actions = {
    [GET_LIST]: async ({commit}) => {
        try {
            commit(CHANGE_LOADING, true);
            commit(SET_LIST, null);
            Promise.all([
                await $http.get(`${process.env.VUE_APP_ROOT_EDUCATION}timetable?include=speakers,picture,picture.seo&skip=${state.skip}&limit=${state.limit}&date_from=${state.date.from}&date_to=${state.date.to}`),
                await $http.get(`${process.env.VUE_APP_ROOT_EVENTS}timetable?include=speakers,picture,picture.seo&skip=${state.skip}&limit=${state.limit}&date_from=${state.date.from}&date_to=${state.date.to}`),
                await $http.get(`${process.env.VUE_APP_ROOT_COURSE}timetable?include=speakers,picture,picture.seo,course&skip=${state.skip}&limit=${state.limit}&date_from=${state.date.from}&date_to=${state.date.to}`)
            ]).then((response) => {

                commit(SET_LIST, response);
                commit(CHANGE_LOADING, false);
                return response;
            })

        } catch (e) {
            commit(CHANGE_LOADING, false);
            throw e;
        }
    },
    [GET_LIST_COUNT]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING, true);

            Promise.all([
                await $http.get(`${process.env.VUE_APP_ROOT_EDUCATION}timetable/count?date_from=${payload.from}&date_to=${payload.to}`),
                await $http.get(`${process.env.VUE_APP_ROOT_EVENTS}timetable/count?date_from=${payload.from}&date_to=${payload.to}`),
                await $http.get(`${process.env.VUE_APP_ROOT_COURSE}timetable/count?date_from=${payload.from}&date_to=${payload.to}`)
            ]).then((response) => {
                commit(SET_LIST_COUNT, response);
                commit(CHANGE_LOADING, false);
            })

        } catch (e) {
            commit(CHANGE_LOADING, false);
            throw e;
        }
    },
    [GET_LIST_ITEM]: async ({commit}, payload) => {
        try {
            commit(CHANGE_LOADING, true);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_EVENTS}events/${payload.slug}?include=speakers,seo,content,type,picture,cover&use_as_id=slug`);
            commit(SET_ITEM, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(CHANGE_LOADING, false);
        }
    },
};

const mutations = {
    [SET_LIST](state, data) {
        if (!data) {
            state.list = null;
            return;
        }
        const formattedArr = [];
        data.forEach(e => {
            Object.values(e.data.data).forEach(t => {
                if (!Array.isArray(t)) return
                formattedArr.push(...t)
            })
        })
        state.list = formattedArr;
    },
    [SET_LIST_LENGTH](state, length) {
        state.listLength = length;
    },
    [SET_LIST_COUNT](state, list1) {
        const transformedArr = []
        list1.forEach(e => {
            const list = e.data.data

            if (Array.isArray(list)) return
            Object.keys(list).forEach(e => {
                const obj = {}
                obj.date = `${e.substr(0, 4)}-${e.substr(4, 2)}-${e.substr(6, 2)}`
                obj.count = list[e]
                transformedArr.push(obj)
            })
        })

        state.listCount = _(transformedArr)
            .groupBy('date')
            .map((objs, key) => {
                return {
                    'date': key,
                    'count': _.sumBy(objs, 'count')
                }
            })
            .value();
    },
    [CHANGE_SKIP](state) {
        state.skip += state.limit;
    },
    [SET_ITEM](state, data) {
        if (data && data.hasOwnProperty('authors')) {
            data.speakers = data.authors
        }
        state.currentItem = data;
    },
    [CHANGE_LOADING](state, status) {
        state.isLoading = status;
    },
    [CHANGE_DATE](state, date) {
        state.date = date;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
